/* Store Ec · dos líneas que no se mezclan en un mismo pago.
   · Entrega en 24 h (etiqueta «nacional»): se paga AL RECIBIR con el formulario de EasySell.
   · Importados: se pagan con tarjeta en el pago de Shopify.
   Si el carrito tiene de las dos, el cliente pide primero una línea; la otra se guarda en este navegador
   y vuelve sola al carrito cuando ya no quedan productos de la línea que se pidió. */
(function(){
  'use strict';
  var NAC = window.X13_NACIONAL || [], CLAVE = 'x13_guardado', VIDA = 7 * 24 * 3600 * 1000;
  var L = window.X13L = window.X13L || {};
  L.esNacional = function(item){ return NAC.indexOf(item.product_id) > -1; };

  function leer(){ try{ var g = JSON.parse(localStorage.getItem(CLAVE) || 'null'); if(g && Date.now() - g.t < VIDA && g.items && g.items.length) return g; }catch(e){} return null; }
  function escribir(g){ try{ if(g) localStorage.setItem(CLAVE, JSON.stringify(g)); else localStorage.removeItem(CLAVE); }catch(e){} }
  function carrito(){ return fetch('/cart.js', { headers:{ Accept:'application/json' } }).then(function(r){ return r.json(); }); }

  /* Guarda para después las líneas del carrito de un tipo («nacional» o «importados») y las quita del carrito. */
  L.apartar = function(tipo, cart){
    var quitar = (cart.items || []).filter(function(it){ return (tipo === 'nacional') === L.esNacional(it); });
    if(!quitar.length) return Promise.resolve(cart);
    var g = leer(); if(g && g.tipo !== tipo) g = null;
    g = g || { tipo: tipo, items: [] }; g.t = Date.now();
    quitar.forEach(function(it){ g.items.push({ id: it.variant_id, quantity: it.quantity, properties: it.properties || {} }); });
    escribir(g);
    var up = {}; quitar.forEach(function(it){ up[it.key] = 0; });
    return fetch('/cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify({ updates: up }) }).then(function(r){ return r.json(); });
  };

  /* Devuelve al carrito lo guardado. */
  L.devolver = function(){
    var g = leer(); if(!g) return Promise.resolve(null);
    return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify({ items: g.items }) })
      .then(function(r){ return r.json(); }).then(function(j){ escribir(null); return j; });
  };

  /* Al cargar cualquier página: si en el carrito ya no queda nada de la línea que se estaba pidiendo, se devuelve lo guardado. */
  function revisar(){
    var g = leer(); if(!g) { try{ localStorage.removeItem(CLAVE); }catch(e){} return; }
    carrito().then(function(c){
      var otra = (c.items || []).some(function(it){ return (g.tipo === 'nacional') !== L.esNacional(it); });
      if(otra){ avisoGuardado(g); return; }
      L.devolver().then(function(){ if(location.pathname === '/cart') location.reload(); else refrescarBurbuja(); });
    }).catch(function(){});
  }
  function refrescarBurbuja(){
    fetch(location.pathname + '?sections=cart-icon-bubble', { headers:{ Accept:'application/json' } }).then(function(r){ return r.json(); }).then(function(d){
      var el = document.getElementById('cart-icon-bubble'), h = d && d['cart-icon-bubble']; if(!el || !h) return;
      var s = new DOMParser().parseFromString(h, 'text/html').querySelector('.shopify-section'); if(s) el.innerHTML = s.innerHTML;
    }).catch(function(){});
  }
  /* En el carrito: recuerda lo guardado y deja traerlo de vuelta. */
  function avisoGuardado(g){
    var caja = document.querySelector('[data-x13-linea-pago]') || document.querySelector('.cart__ctas'); if(!caja || document.querySelector('.x13-guardado')) return;
    var n = 0; g.items.forEach(function(i){ n += Number(i.quantity) || 1; });
    var p = document.createElement('p'); p.className = 'x13-guardado';
    p.style.cssText = 'margin:10px 0 0;font-size:14px;line-height:1.45;color:#3B4651';
    p.textContent = 'Tienes ' + n + (n === 1 ? ' producto guardado' : ' productos guardados') + (g.tipo === 'nacional' ? ' nacionales' : ' importados') + ' para pedir después. ';
    var b = document.createElement('button'); b.type = 'button'; b.textContent = 'Volver a ponerlos en el carrito';
    b.style.cssText = 'background:none;border:0;padding:0;font:inherit;font-weight:700;color:#0C7889;text-decoration:underline;cursor:pointer;min-height:44px';
    b.addEventListener('click', function(){ b.disabled = true; L.devolver().then(function(){ location.reload(); }); });
    p.appendChild(b); caja.parentNode.insertBefore(p, caja.nextSibling);
  }

  /* Botones del carrito: «Pedir los nacionales» y «Pagar los importados con tarjeta». */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-x13-pedir]'); if(!b) return;
    e.preventDefault();
    var tipo = b.getAttribute('data-x13-pedir'), caja = b.closest('[data-x13-linea-pago]'), url = caja && caja.getAttribute('data-nac-url');
    b.disabled = true; b.setAttribute('aria-busy', 'true');
    carrito().then(function(c){ return L.apartar(tipo === 'nacional' ? 'importados' : 'nacional', c); }).then(function(){
      if(tipo === 'nacional') location.href = (url || '/collections/nacional') + '?pedido=carrito';
      else location.href = '/checkout';
    }).catch(function(){ b.disabled = false; b.removeAttribute('aria-busy'); if(window.X13T && window.X13T.aviso) window.X13T.aviso('No se pudo continuar. Intenta de nuevo.', true); });
  });

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revisar); else revisar();
})();
